import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { InterestAcrualType } from '../../../../../../../../../common/constants/InterestAcrualType';

/** Interest Accrual when none has been chosen: 30/360 for Rental and Bridge loans, Actual/360 for everything else. */
export const getDefaultInterestAccrualType = (loanTypeId: LoanType | undefined) =>
    loanTypeId === LoanType.Rental || loanTypeId === LoanType.Bridge
        ? InterestAcrualType.Thirty360
        : InterestAcrualType.Actual360;
